export const weekdaysRoutesName = {
    weekdays: "weekdays",
};
